import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Zap, Cloud, Hexagon } from "react-feather";

// These values must match the backend's accepted values exactly
export type AIModel = "claude" | "gemini" | "journey_ai";

interface ModelSelectorProps {
	selectedModel: AIModel;
	onModelSelect: (model: AIModel) => void;
	className?: string;
}

const ModelSelector: React.FC<ModelSelectorProps> = ({
	selectedModel,
	onModelSelect,
	className = ""
}) => {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const toggle = () => setDropdownOpen((prevState) => !prevState);

	const models = [
		{
			id: "claude" as AIModel,
			name: "Claude",
			description: "Expert for complex reasoning",
			icon: <Cloud size={16} className="text-primary" />,
			color: "#7C3AED"
		},
		{
			id: "gemini" as AIModel,
			name: "Gemini",
			description: "Fast and versatile",
			icon: <Zap size={16} className="text-warning" />,
			color: "#F59E0B"
		},
		{
			id: "journey_ai" as AIModel,
			name: "Journey AI",
			description: "Proprietary product intelligence",
			icon: <Hexagon size={16} className="text-danger" />,
			color: "#EF4444"
		}
	];

	const currentModel = models.find((m) => m.id === selectedModel) || models[0];

	return (
		<div className={`model-selector-wrapper ${className}`}>
			<Dropdown isOpen={dropdownOpen} toggle={toggle} className="model-selector-dropdown">
				<DropdownToggle
					caret
					color="outline-secondary"
					className="d-flex align-items-center gap-2 py-1 px-3 rounded-pill shadow-sm bg-white border"
				>
					<div className="model-icon-small">{currentModel.icon}</div>
					<span className="model-name fw-bold small">{currentModel.name}</span>
				</DropdownToggle>
				<DropdownMenu className="model-dropdown-menu shadow-lg border-0 mt-2 p-2" end>
					<div className="px-3 py-2 text-muted x-small fw-bold text-uppercase letter-spacing-1">
						Choose AI Model
					</div>
					{models.map((model) => (
						<DropdownItem
							key={model.id}
							active={selectedModel === model.id}
							onClick={() => onModelSelect(model.id as AIModel)}
							className="rounded-3 mb-1 d-flex align-items-center gap-3 py-2 px-3"
						>
							<div className="model-icon-circle p-2 rounded-circle bg-light">{model.icon}</div>
							<div className="model-info">
								<div className="model-title fw-bold small">{model.name}</div>
								<div className="model-desc x-small text-muted">{model.description}</div>
							</div>
						</DropdownItem>
					))}
				</DropdownMenu>
			</Dropdown>
		</div>
	);
};

export default ModelSelector;
